import DocumentProcessingIcon from './DocumentProcessingIcon'

export default DocumentProcessingIcon
